import React, { useEffect } from "react";
import DynamicAboutSection from "../../components/CorporateTeamBuilding/DynamicAbout";
import TeamActivitySection from "../../components/CorporateTeamBuilding/TeamActivitySection";
import DynamicCorporateTeamSection from "../../components/CorporateTeamBuilding/DynamicCorporateTeamSection";
import DynamicMethodSection from "../../components/CorporateTeamBuilding/DynamicMethodSection";
import HowTeamsWorkSection from "../../components/CorporateTeamBuilding/HowTeamsWorkSection";
import DynamicDeliverableSection from "../../components/CorporateTeamBuilding/DynamicDeliverableSection";
import DynamicGallerySection from "../../components/CorporateTeamBuilding/DynamicGallerySection";
import DynamicExpertiseSection from "../../components/CorporateTeamBuilding/DynamicExpertiseSection";
import DynamicContactSection from "../../components/CorporateTeamBuilding/DynamicContactSection";
import CorporateTeamBuildingHeaderSection from "../../components/CorporateTeamBuilding/CorporateTeamBuildingHeaderSection";
import CorporateTeamBuildingTestimonial from "../../components/CorporateTeamBuilding/CorporateTeamBuildingTestimonial";

import CorporateTeamBuildingFaqSection from "../../components/CorporateTeamBuilding/CorporateTeamBuildingFaqSection";
import corporateTeamBuildingData from "../../data/corporateTeamBuildingData.json";
import "../Dynamic/dynamic.css";


export default function CorporateTeamBuilding({ data = corporateTeamBuildingData }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dynamic-page dynamic-team-building-page">
      <CorporateTeamBuildingHeaderSection data={data.header} />
      <DynamicAboutSection data={data.dynamicAbout} />  
      <TeamActivitySection data={data.teamActivities} />
      <DynamicCorporateTeamSection data={data.corporateTeam} />
      <DynamicMethodSection data={data.method} />
      <HowTeamsWorkSection data={data.teamWork} />
      <DynamicDeliverableSection data={data.deliverable} />
      <DynamicGallerySection data={data.gallery} />
      <DynamicExpertiseSection data={data.expertise} />
      <CorporateTeamBuildingTestimonial data={data.testimonials} />  
      <CorporateTeamBuildingFaqSection data={data.faq} />
      <DynamicContactSection data={data.contact} />
    </div>
  );
}
